var exports = {
  "Dk": "x620889e6--7794a0--carousel",
  "hJ": "x620889e6--7794a0--counter",
  "MF": "x620889e6--7794a0--single-photo",
};

module.exports = exports;
